import {
  TeacherStatus,
  getTotalTeachersByStatus,
} from "../../services/teacher.service";
import { useEffect, useState } from "react";

import { API_URL } from "../../utils/constants";
import Card from "../../components/cards/Card";
import Dashboard from "../dashboard/Dashboard";
import { NavLink } from "react-router-dom";
import { getRequest } from "../../services/api.service";
import showToast from "../../utils/show.toast";

interface ITotalStudentResponse {
  statusCode: number;
  status: string;
  message: string;
  result: {
    total: number;
  };
}

export default function Overview() {
  const [isLoadingTeachersCount, setIsLoadingTeachersCount] =
    useState<boolean>(false);
  const [teachersCount, setTeachersCount] =
    useState<Record<TeacherStatus, number>>();
  const [studentCount, setStudentCount] = useState<{ total: number }>({
    total: 0,
  });

  useEffect(() => {
    const fetchData = async () => {
      setIsLoadingTeachersCount(true);
      try {
        const [teachersCount, studentCount] = await Promise.all([
          getTotalTeachersByStatus(),
          getRequest<ITotalStudentResponse>(`${API_URL}/student/total`),
        ]);

        setTeachersCount(teachersCount);
        setStudentCount({ total: studentCount.result.total });
      } catch (error) {
        const message =
          error instanceof Error
            ? error.message
            : "Apologies, an error occured. Please, try again later.";
        return showToast(message, false);
      } finally {
        setIsLoadingTeachersCount(false);
      }
    };
    fetchData();
  }, []);

  return (
    <Dashboard pageTitle="Overview">
      <div className="card-container">
        <NavLink to={`/teachers/list?status=${TeacherStatus.REGISTERED}`}>
          <Card
            title="Unreviewed Teachers"
            description="Total registered teachers yet to be reviewed"
            number={teachersCount?.registered ?? 0}
            isLoading={isLoadingTeachersCount}
          />
        </NavLink>

        <NavLink to={`/teachers/list?status=${TeacherStatus.ACCEPTED}`}>
          <Card
            title="Reviewed Teaches"
            description={
              isLoadingTeachersCount ? "Loading" : "Total reviewed teachers "
            }
            number={teachersCount?.accepted ?? 0}
            isLoading={isLoadingTeachersCount}
          />
        </NavLink>

        <NavLink to={`/teachers/list?status=${TeacherStatus.VERIFIED}`}>
          <Card
            title="Verified Teachers"
            description={
              isLoadingTeachersCount ? "Loading" : "Total teachers verified"
            }
            number={teachersCount?.verified ?? 0}
            isLoading={isLoadingTeachersCount}
          />
        </NavLink>

        <NavLink to={`/students`}>
          <Card
            title="Total Students"
            description={
              isLoadingTeachersCount ? "Loading" : "Total number of students"
            }
            number={studentCount.total ?? 0}
            isLoading={isLoadingTeachersCount}
          />
        </NavLink>
      </div>
    </Dashboard>
  );
}
